import React, { useContext } from 'react'
import { AuthAPI } from '../api'
import { Alerts } from '../components/Simple'
import { LocalStorage } from '../services'
import { FormatPhone } from '../utils'
import validator from 'validator'
import { BLACKLISTED_DOMAINS } from '../utils/constants'
import { CookieConsentContext } from './CookieConsentContext'

export const AuthContext = React.createContext({
  sttAuthCtx: {
    isLogged: LocalStorage.get('user-isLoged') || false,
    isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
    width: window.innerWidth,
    height: window.innerHeight,
    // Lista de {email e createdAt} para verificar se o usuário já solicitou um código
    listEmails: LocalStorage.get('user-emails-validate') || null,
  },
  loadsAuth: 'off',
  calculateProgress: () => {},
  actionsAuth: {
    // eslint-disable-next-line no-unused-vars
    VerificaEmail: async email => {},
    // eslint-disable-next-line no-unused-vars
    ValidarRefreshToken: async () => {},
    // eslint-disable-next-line no-unused-vars
    EnviarCodigoEmail: async email => {},
    // eslint-disable-next-line no-unused-vars
    Cadastrar: async () => {},
    // eslint-disable-next-line no-unused-vars
    VerificaCodigoOTP: async code => {},
    // eslint-disable-next-line no-unused-vars
    LoginComProvider: async data => {},
    // eslint-disable-next-line no-unused-vars
    BuscarCidadesAtivas: async () => {},
    // eslint-disable-next-line no-unused-vars
    StartLogout: async () => {},
    // eslint-disable-next-line no-unused-vars
    handleSttAuthCtx: (key, value = null) => {},
    // eslint-disable-next-line no-unused-vars
    handleUserInfo: (key, value = null) => {},
    // eslint-disable-next-line no-unused-vars
    authStep: step => {},
    // eslint-disable-next-line no-unused-vars
    handleInputChange: (key, value) => {},
    // eslint-disable-next-line no-unused-vars
    handleDateChange: date => {},
    // eslint-disable-next-line no-unused-vars
    handleChangePhone: e => {},
    // eslint-disable-next-line no-unused-vars
    handleUiControls: (key, value) => {},
    // eslint-disable-next-line no-unused-vars
    handleLoading: val => {},
    // eslint-disable-next-line no-unused-vars
    clearUiControls: () => {},
  },

  userInfo: {
    name: '',
    email: '',
    otpCode: '',
    pais: '+55',
    phone: '',
    genero: '0',
    nasc: '',
  },
  uiControls: {
    // verificaEmail
    emailHelperText: '',
    emailValido: false,
    //VerificaCodigo
    otpCodeHelperText: '',
    codeValido: null,
    usuarioExistente: null,
    // Conrole da etapa
    step: 'login',
  },
})

export default function AuthContextProvider({ children }) {
  const { cookieConsent } = useContext(CookieConsentContext)
  const [sttAuthCtx, setSttAuthCtx] = React.useState({
    isLogged: LocalStorage.get('user-isLoged') || false,
    isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
    width: window.innerWidth,
    height: window.innerHeight,
    // Lista de {email e createdAt} para verificar se o usuário já solicitou um código
    listEmails: LocalStorage.get('user-emails-validate') || null,
  })
  //console.log('sttAuthCtx', sttAuthCtx)
  const [userInfo, setUserInfo] = React.useState({
    name: '',
    email: '',
    otpCode: '',
    pais: '+55',
    phone: '',
    genero: '0',
    nasc: '',
  })
  const [uiControls, setUIControls] = React.useState({
    emailHelperText: '',
    emailValido: false,
    otpCodeHelperText: '',
    codeValido: null,
    usuarioExistente: null,
    step: 'login',
  })

  const [loadsAuth, setLoadsAuth] = React.useState(LocalStorage.get('action-login-google') || 'off')

  const emailInvalido = helperText => {
    setUIControls(prev => ({
      ...prev,
      emailHelperText: helperText,
      emailValido: false,
    }))
    setLoadsAuth('off')
  }
  // mensagem de sucesso
  const emailValido = helperText => {
    setUIControls(prev => ({
      ...prev,
      emailHelperText: helperText,
      emailValido: true,
    }))
    setLoadsAuth('off')
  }

  const codigoInvalido = helperText => {
    setUIControls(prev => ({
      ...prev,
      otpCodeHelperText: helperText,
      codeValido: false,
    }))
    setLoadsAuth('off')
  }

  function calculateProgress() {
    const fields = [userInfo.name, userInfo.email, userInfo.phone, userInfo.nasc]
    const totalFields = fields.length
    const filledFields = fields.filter(
      field => field !== '' && field !== null && field !== undefined,
    ).length

    let progress = (filledFields / totalFields) * 100

    if (uiControls.step === 'login') {
      progress = 0
    } else if (uiControls.step === 'verifEmail') {
      progress = 25
    } else if (uiControls.step === 'codVerif') {
      progress = 50
    } else if (uiControls.step === 'cadastro') {
      progress = (filledFields / totalFields) * 100
    }

    return progress
  }
  // console.log('isLogged', sttAuthCtx.isLogged, 'loadsAuth', loadsAuth)
  const actionsAuth = {
    ValidarRefreshToken: async () => {
      const user = LocalStorage.get('user-loged')
      if (!user || !user.idusuario) {
        setSttAuthCtx(sttAuthCtx => ({ ...sttAuthCtx, isLogged: false }))
        LocalStorage.clear()
        return { retorno: false }
      }

      const req = await AuthAPI.validarRefreshToken(user.idusuario)
      if (req.error) {
        setSttAuthCtx(sttAuthCtx => ({ ...sttAuthCtx, isLogged: false }))
        LocalStorage.remove('user-loged')
        LocalStorage.remove('user-token')
        LocalStorage.remove('user-isLoged')
        return { retorno: false }
      }
      if (req.retorno) {
        setSttAuthCtx(sttAuthCtx => ({ ...sttAuthCtx, isLogged: true }))
        return { retorno: true }
      } else {
        setSttAuthCtx(sttAuthCtx => ({ ...sttAuthCtx, isLogged: false }))
        LocalStorage.clear()
        return { retorno: false }
      }
    },
    VerificaEmail: async email => {
      // mensagem de erro
      if (email === '') {
        return emailInvalido('Por favor, informe um email.')
      } else if (email.length <= 8 || !validator.isEmail(email)) {
        return emailInvalido('E-mail inválido')
      }
      setLoadsAuth('email')
      const domain = email.split('@')[1]
      const isTemporario = BLACKLISTED_DOMAINS.includes(domain)

      if (!isTemporario) {
        return emailValido('E-mail válido')
      } else return emailInvalido('E-mail inválido')
    },
    EnviarCodigoEmail: async email => {
      setLoadsAuth('login')
      const reqs = await AuthAPI.enviarCodigoAutenticacao(email)
      //console.log('reqs', reqs)
      if (reqs.error) {
        // Verifica se tem a regra de 2 minutos!
        if (
          reqs.erro.response.data.message.erro === 'ERRO_REGRA_NEGOCIO' &&
          !reqs.erro.response.data.message.retorno
        ) {
          return emailInvalido(
            'Você já solicitou um código, aguarde 2 minutos para solicitar novamente',
          )
        }
        return emailInvalido('Erro de comunicação, tente novamente mais tarde.')
      }
      if (reqs.message === 'Código enviado') {
        // Gerencia a lista de emails

        setSttAuthCtx(sttAuthCtx => ({
          ...sttAuthCtx,
          listEmails: { email, createdAt: new Date() },
        }))
        Alerts.swal('success', 'Código enviado', 'Verifique seu e-mail e insira o código recebido')
        setUIControls(prev => ({ ...prev, step: 'codVerif' }))
      } else {
        //console.log('reqs.message', reqs)
        Alerts.swal('warning', 'Aviso', reqs.message)
      }
      setLoadsAuth('off')
    },
    VerificaCodigoOTP: async code => {
      setLoadsAuth('login')
      const req = await AuthAPI.verificarCodigoAutenticacao(userInfo.email, code)
      if (!req) return codigoInvalido('Erro de comunicação, tente novamente mais tarde')
      if (req.error)
        codigoInvalido('Estamos com problemas para validar o código. Por favor tente novamente')
      if (req.retorno === false) {
        codigoInvalido('Código inválido ou expirado, confira e digite o código novamente.')
        return req
      } else if (req.retorno === true) {
        if (req.type === 1) {
          setUserInfo(userInfo => ({ ...userInfo, email: '', otpCode: '' }))
          setSttAuthCtx(sttAuthCtx => ({ ...sttAuthCtx, isLogged: true, listEmails: null })) // Limpa a lista de emails
          LocalStorage.set('user-isLoged', true)
          LocalStorage.remove('user-emails-validate')
          // Envia e-mail do usuário para o dataLayer (retize)
          if (window.dataLayer && cookieConsent.ad_storage) {
            window.dataLayer.push({ event: 'userIdentified', id_usuario: req.usuario.username })
          }
          setLoadsAuth('off')
          return req
        } else {
          // Usuário ainda não cadastrado
          setUIControls(prev => ({ ...prev, step: 'cadastro', listEmails: [] }))
          LocalStorage.remove('user-emails-validate')
          setLoadsAuth('off')
          return { ...req, retorno: false }
        }
      }
    },
    LoginComProvider: async data => {
      setLoadsAuth('login-google')
      const req = await AuthAPI.loginComProvider(data)

      if (req.error) {
        Alerts.swal('warning', 'Aviso', req.detalhes)
        setLoadsAuth('off')
        return req
      }

      if (req.usuario && req.tokens) {
        LocalStorage.set('user-isLoged', true)
        setSttAuthCtx(sttAuthCtx => ({ ...sttAuthCtx, isLogged: true }))
        setUserInfo(userInfo => ({ ...userInfo, email: '', otpCode: '' }))
        // Envia e-mail do usuário para o dataLayer (retize)
        if (window.dataLayer && cookieConsent.ad_storage) {
          window.dataLayer.push({ event: 'userIdentified', id_usuario: req.usuario.username })
        }
        setLoadsAuth('off')
        return req
      }

      setLoadsAuth('off')
    },
    Cadastrar: async () => {
      const Atleta = {
        nome: userInfo.name,
        email: userInfo.email,
        telefone: userInfo.phone,
        nascimento: userInfo.nasc,
        sexo:
          userInfo.genero === '0'
            ? ''
            : userInfo.genero === 'M'
              ? 'Masculino'
              : userInfo.genero === 'F'
                ? 'Feminino'
                : 'Outro',
        fromSite: true,
      }

      const user = {
        nome: userInfo.name,
        username: userInfo.email,
        telefone: userInfo.phone,
        usuario: userInfo.email,
        email: userInfo.email,
        nascimento: userInfo.nasc,
        sexo:
          userInfo.genero === '0'
            ? ''
            : userInfo.genero === 'M'
              ? 'Masculino'
              : userInfo.genero === 'F'
                ? 'Feminino'
                : 'Outro',
        admin: 0,
        exclusivo: 0,
        adminGeral: 0,
        atleta: Atleta,
      }

      const data = {
        user,
        email: userInfo.email,
        code: userInfo.otpCode,
        tokenDispositivo: null,
      }

      setUIControls(uiControls => ({ ...uiControls, loading: true }))
      const req = await AuthAPI.cadastrar(data)
      //console.log('Return ::', req)
      if (req.error || !req.usuario || !req.tokens) {
        Alerts.swal('warning', 'Aviso', req.detalhes)
        setUserInfo(userInfo => ({ ...userInfo, name: '', phone: '', nasc: '', genero: '0' }))
        setUIControls(uiControls => ({ ...uiControls, loading: false }))
        return req
      } else {
        LocalStorage.set('user-isLoged', true)
        setSttAuthCtx(sttAuthCtx => ({ ...sttAuthCtx, isLogged: true }))
        setUserInfo(userInfo => ({
          ...userInfo,
          email: '',
          otpCode: '',
          nome: '',
          phone: '',
          nasc: '',
          genero: '0',
        }))
        setUIControls(uiControls => ({ ...uiControls, loading: false }))
        return { ...req, retorno: true }
      }
    },
    BuscarCidadesAtivas: async () => {
      const req = await AuthAPI.buscarCidadesAtivas()
      return req
    },
    StartLogout: async () => {
      setLoadsAuth('settings-page')
      const req = await AuthAPI.logout(sttAuthCtx.accessToken)
      if (req.error) {
        Alerts.swal(
          'warning',
          'Aviso',
          'Parece que tivemos um problema ao tentar realizar essa ação. Por favor verifique sua conexão com a internet e tente novamente.',
        )
        setLoadsAuth('off')
        return { retorno: false }
      }
      // setSttAuthCtx(sttAuthCtx => ({ ...sttAuthCtx, isLogged: false }))
      // Joga UI para login se não tiver
      // LocalStorage.clear()
      setLoadsAuth('off')
    },
    handleChangePhone: e => {
      setUserInfo(userInfo => ({
        ...userInfo,
        phone: FormatPhone(e.target.value, userInfo.pais),
      }))
    },
    handleSttAuthCtx: (key, value = null) => {
      if (key === 'token' && value !== null) {
        LocalStorage.set('user-token', value)
      } else if (key === 'isLogged' && value !== null) {
        LocalStorage.set('user-isLoged', value)
      }
      setSttAuthCtx(sttAuthCtx => ({ ...sttAuthCtx, [key]: value }))
    },
    handleInputChange: (key, value) => {
      if (key !== 'otpCode') {
        setUserInfo(userInfo => ({ ...userInfo, [key]: value.target.value }))
      } else {
        setUserInfo(userInfo => ({ ...userInfo, [key]: value }))
        setUIControls(uiControls => ({
          ...uiControls,
          otpCodeHelperText: '',
          codeValido: null,
          usuarioExistente: null,
        }))
      }
    },
    handleDateChange: date => {
      setUserInfo(userInfo => ({ ...userInfo, nasc: date }))
    },
    handleUiControls: (key, value) => {
      //console.log('key', key, 'value', value)
      setUIControls(uiControls => ({ ...uiControls, [key]: value }))
    },
    clearUiControls: () => {
      setUIControls({
        emailHelperText: '',
        emailValido: false,
        otpCodeHelperText: '',
        codeValido: null,
        usuarioExistente: null,
        step: 'login',
      })
    },
    authStep: step => {
      // login -> verifEmail -> codVerif -> cadastro
      setUIControls(uiControls => ({ ...uiControls, step }))
    },
    handleLoading: val => {
      setLoadsAuth(val)
    },
  }

  React.useEffect(() => {
    function handleResize() {
      setSttAuthCtx(sttAuthCtx => ({
        ...sttAuthCtx,
        width: window.innerWidth,
        height: window.innerHeight,
      }))
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <AuthContext.Provider
      value={{
        sttAuthCtx,
        loadsAuth,
        calculateProgress,
        actionsAuth,
        userInfo,
        uiControls,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}
